// suver-gads-attribution.js — snippet para el TEMA de suver.cl
// (fuente de verdad: Cotizador/docs/suver-gads-attribution.js)
//
// Dos funciones activas, todas best-effort (jamás rompen la navegación):
//  1. Captura gclid/gbraid/wbraid al aterrizar desde un anuncio → localStorage
//     (90 días, la misma ventana de la acción de conversión) y lo registra en
//     el Cotizador con un código corto (POST /api/public/gads-ref).
//  2. Dispara el evento GA4 `email_click` en clics a mailto: — la medición
//     mejorada de GA4 NO captura mailto, por eso la acción de Ads llevaba
//     0 conversiones de por vida.
//
// RETIRADO 2026-08-15 (pedido del dueño): el anexo "ref:W-XXXXXX" al texto
// prellenado de WhatsApp. Los wa.me del sitio apuntan a la línea de las
// vendedoras (app Business, sin webhook), así que el código llegaba visible
// y nadie lo leía. Reponer cuando el WhatsApp del Cotizador (+56 9 6508 0261,
// Cloud API con webhook) salga a público: ahí el código sí cierra el join
// clic → teléfono → cierre. La versión con el ref quedó en el historial git
// del archivo fuente.
//
// La cotización web manda el clic directo: window.SuverGads.click() expone
// {gclid|gbraid|wbraid} para incluirlo como `gads` en POST /api/public/cotizar.
(function () {
  var KEY = "suver_gads";
  var TTL_MS = 90 * 86400000;
  var COTIZADOR = "https://cotizador-suver.up.railway.app";
  var ID_RE = /^[\w.-]{8,200}$/;

  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || "null");
      if (!d || !d.ts || Date.now() - d.ts > TTL_MS) return null;
      return d;
    } catch (e) {
      return null;
    }
  }

  // 1) Captura al aterrizar. El código es estable por visitante; un aterrizaje
  // posterior con OTRO clic actualiza el clic guardado (último clic pagado).
  try {
    var params = new URLSearchParams(location.search);
    var click = {};
    ["gclid", "gbraid", "wbraid"].forEach(function (k) {
      var v = params.get(k);
      if (v && ID_RE.test(v)) click[k] = v;
    });
    if (Object.keys(click).length > 0) {
      var prev = read();
      var code =
        (prev && prev.code) ||
        "W-" +
          Date.now().toString(36).slice(-3).toUpperCase() +
          Math.random().toString(36).slice(2, 5).toUpperCase();
      localStorage.setItem(
        KEY,
        JSON.stringify({ click: click, code: code, landing: location.pathname, ts: Date.now() })
      );
      fetch(COTIZADOR + "/api/public/gads-ref", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          code: code,
          landing: location.pathname,
          gclid: click.gclid,
          gbraid: click.gbraid,
          wbraid: click.wbraid,
        }),
        keepalive: true,
      }).catch(function () {});
    }
  } catch (e) {}

  // 2) email_click para GA4 (mailto no lo cubre la medición mejorada)
  document.addEventListener(
    "click",
    function (ev) {
      try {
        var a = ev.target && ev.target.closest ? ev.target.closest('a[href^="mailto:"]') : null;
        if (a && typeof window.gtag === "function") {
          window.gtag("event", "email_click", { link_url: a.getAttribute("href") });
        }
      } catch (e) {}
    },
    true
  );

  // API mínima para el carrito/cotizador web
  window.SuverGads = {
    click: function () {
      var d = read();
      return d ? d.click : null;
    },
    code: function () {
      var d = read();
      return d ? d.code : null;
    },
  };
})();
